import { Room, TwilioError } from 'twilio-video';
import { useEffect } from 'react';

import { Callback } from 'features/video-conference/constants/types';

export default function useHandleRoomDisconnection(
  room: Room | null,
  removeLocalAudioTrack: () => void,
  removeLocalVideoTrack: () => void,
  isSharingScreen: boolean,
  toggleScreenShare: () => void,
  onError: Callback,
) {
  useEffect(() => {
    if (room) {
      const onDisconnected = (_: Room, error: TwilioError) => {
        if (error) {
          onError(error, true);
        }

        removeLocalAudioTrack();
        removeLocalVideoTrack();

        if (isSharingScreen) {
          toggleScreenShare();
        }
      };

      room.on('disconnected', onDisconnected);
      return () => {
        room.off('disconnected', onDisconnected);
      };
    }

    return () => {};
  }, [
    room,
    removeLocalAudioTrack,
    removeLocalVideoTrack,
    isSharingScreen,
    toggleScreenShare,
    onError,
  ]);
}
